var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton"},_vm._l((_vm.amount),function(i){return _c('div',{key:i,staticClass:"skeleton__block",style:(_vm.setHeight)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }